import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { handleError } from 'services/ErrorManagement';

export const RemoveParentProductDialog = ({ parentToRemove = undefined, onConfirm, onClose }) => {
    const [isRemoving, setIsRemoving] = useState(false);

    const handleConfirm = async () => {
        setIsRemoving(true);
        try {
            await onConfirm();
            onClose();
        } catch (err) {
            handleError('Unable to remove product.', err);
        } finally {
            setIsRemoving(false);
        }
    };

    return (
        <WarningDialog
            dialogTitle="Remove Parent Product"
            width={600}
            isOpen={!!parentToRemove}
            primaryButtonIntent={Button.Intent.DANGER}
            primaryButtonLabel="Yes, Remove"
            primaryButtonDisabled={isRemoving}
            secondaryButtonLabel="No, Cancel"
            onPrimaryButtonClick={handleConfirm}
            onSecondaryButtonClick={onClose}
            dialogContent={
                <p>
                    {`Remove ${parentToRemove?.displayName ?? 'this parent product'}? This removes the whole parent product and every OID under it, not just the row you clicked.`}
                </p>
            }
        />
    );
};

RemoveParentProductDialog.propTypes = {
    parentToRemove: PropTypes.shape({
        displayName: PropTypes.string,
    }),
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};
